angular.module('kareo.ui.shared.directives', [
  'kareo.ui.shared.directives.templates',
  'kareo.ui.shared.directives.analytics',
  'kareo.ui.shared.directives.chrome-header',
  'kareo.ui.shared.directives.content-height',
  'kareo.ui.shared.directives.currency',
  'kareo.ui.shared.directives.date-range',
  'kareo.ui.shared.directives.dropdown',
  'kareo.ui.shared.directives.validation.input-group',
  'kareo.ui.shared.directives.k-step-nav',
  'kareo.ui.shared.directives.messaging-dropdown',
  'kareo.ui.shared.directives.outstanding-items',
  'kareo.ui.shared.directives.patient-create',
  'kareo.ui.shared.directives.percent',
  'kareo.ui.shared.directives.validation.prevent-form-submit',
  'kareo.ui.shared.directives.profile-image',
  'kareo.ui.shared.directives.relative-time',
  'kareo.ui.shared.directives.tour-card',
  'kareo.ui.shared.directives.trial-feature-gate',
  'kareo.ui.shared.directives.ui-mask',
  'kareo.ui.shared.directives.pagination',
  'kareo.ui.shared.directives.patient-nav',
  'kareo.ui.shared.directives.k-patient-check-eligibility',
  'kareo.ui.shared.directives.billing-workflow.search-work-item',
  'kareo.ui.shared.directives.choose-kmb-document',
  'kareo.ui.shared.directives.ka-collapsable-ul',
  'kareo.ui.shared.directives.chart-navbar',
  'directives.billing-workflow.billing-tasks-assigned',
  'kareo.ui.shared.directives.psych-note-my-settings',
  'app.eligibility-report-modal']);
